import $ from 'jquery';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Cookies from 'universal-cookie';
import fakeResponse from '../src/apiFakeResponse';

const IS_DEBUG = false;

const API = {
	_cookie: {
		write: param => {
			let cookieContent = `${param.name}=${param.value}`;

			if (param.hours) {
				var date = new Date();
				date.setTime(date.getTime() + (param.hours * 60 * 60 * 1000));
				cookieContent += `; expires=${date.toGMTString()}`
			}

			if (param.domain) {
				cookieContent += `; domain=${param.domain}`;
			}
			cookieContent += "; path=/";
			document.cookie = cookieContent;
		},
		read: name => {
			const ca = document.cookie.split(';');
			const nameEQ = `${name}=`;
			for (let i = 0, c; c = ca[i]; i++) {
				while (c.charAt(0) == ' ') {
					c = c.substring(1, c.length);
				}
				if (c.indexOf(nameEQ) == 0) {
					return c.substring(nameEQ.length, c.length);
				}
			}
			return '';
		}
	},
	getPromise: async function (data, passJson) {
		if (IS_DEBUG) {
			if (!fakeResponse.hasOwnProperty(data.path)) console.warn("[unknown API]", data.path);
			console.log(data);
			var response = await Promise.resolve(new Response(JSON.stringify(
				fakeResponse[data.path] || {}
			)));
			var jsonResponse = await response.json();
			return { response: response, responseData: jsonResponse };
		}

		var url = data.isFullPath ? data.path : API._root + data.path;
		data.headers = data.headers || {};
		if (false != data.isAutoCompleteHeader) {
			if (API.token) {
				data.headers.tk = API.token;
			}
			if (API.accessID) {
				data.headers.ac = API.accessID;
			}
		}
		console.log(url, data);

		API.setIsLoading(true);
		// console.log("[isLoading]", url, API.getIsLoading())
		var response = await fetch(url, {
			body: (data.body && false != data.isJson) ? JSON.stringify(data.body) : data.body, // must match 'Content-Type' header
			cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
			credentials: 'same-origin', // include, same-origin, *omit
			headers: data.headers,
			method: data.method || "GET", // *GET, POST, PUT, DELETE, etc.
			mode: 'cors', // no-cors, cors, *same-origin
			// redirect: 'follow', // manual, *follow, error
			// referrer: 'no-referrer', // *client, no-referrer
		});
		API.setIsLoading(false);
		// console.log("[isLoading]", url, API.getIsLoading())

		console.log(response);
		if (401 == response.status) {
			console.log(API, API.currentView);
			console.log(this, window);
			alert("已被登出,請重新登入");
			if (API.currentView) API.currentView.props.history.push(API.login_page);
			return { response: response, responseData: null };
		} else if (400 <= response.status && 500 > response.status && 404 != response.status) {
			alert("喔喔...server說有問題喔 (error:" + response.status);
			// // location.href = API.default_page;
			// API.currentView.props.history.push(API.default_page);
			console.log("[location]", API.default_page);
		} else if (500 <= response.status && 600 > response.status) {
			console.error("server error (error:" + response.status);
		}

		console.log("passJson", passJson)
		if (passJson) {
			var blobRes = await response.blob();
			console.log(blobRes);
			return { response: response, responseData: blobRes };
		} else {
			var jsonResponse = await response.json();
			if (null != jsonResponse && "24014" == jsonResponse.code) {
				alert("已被登出,請重新登入");
				if (API.currentView) API.currentView.props.history.push(API.login_page);
				return { response: response, responseData: null };
			}
			return { response: response, responseData: jsonResponse };
		}
	},
	ajaxSend: function (path, method, headers, data, onSucc, onFail, isFullPath) {
		function onLogout() {
			alert("已被登出, 請重新登入");
			console.log(API, API.currentView);
			if (API.currentView) API.currentView.props.history.push(API.login_page);
			console.log("[location]", API.login_page);
		}

		if (IS_DEBUG) {
			if (!fakeResponse.hasOwnProperty(path)) console.warn("[unknown API]", path);
			console.log(path);
			setTimeout(function () {
				if (onSucc) onSucc(fakeResponse[path]);
			})
			return;
		}

		var url = isFullPath ? path : API._root + path;
		if (API.token) {
			headers.tk = API.token;
		}
		if (API.accessID) {
			headers.ac = API.accessID;
		}
		console.debug(url, API.token);

		// console.warn("[ajax]",method,url,headers,data);
		API.setIsLoading(true);
		// console.log("[isLoading]", url, API.getIsLoading())
		$.ajax({
			type: method,
			url: url,
			headers: headers,
			dataType: "json",
			contentType: "application/json; charset=utf-8",
			data: data ? JSON.stringify(data) : null,
		})
			.done(function (data, textStatus, jqXHR) {
				API.setIsLoading(false);
				// console.log("[isLoading]", url, API.getIsLoading())
				if (false == (null != data && "24014" == data.code)) {
					if (onSucc) onSucc(data, jqXHR);
				} else {
					onLogout();
				}
			}).fail(function (jqXHR, textStatus, errorThrown) {
				API.setIsLoading(false);
				// console.log("[isLoading]", url, API.getIsLoading())
				//if 401, redirect back to login
				if (jqXHR.status >= 200 && jqXHR.status < 300
					&& false == (null != data && "24014" == data.code)) {
					if (onSucc) onSucc(data);
				} else {
					if (onFail) {
						//customize failover
						onFail(jqXHR);
					} else {
						if (401 == jqXHR.status) {
							//session timeout, relogin
							// location.href = API.login_page;
							onLogout();
						} else if (true == API.isRediretIfError && 404 != jqXHR.status) {
							//other error
							alert("喔喔...server說有問題喔 (error:" + jqXHR.status);
							// location.href = API.default_page;
							console.log("[location]", API.default_page);
						}
					}
				}
			});
	},
	currentView: null,
	isTestMode: false,
	isRediretIfError: false,
	root_url: "/",
	login_page: "/login",
	default_page: "/login",
	first_page: "/index",
	signup_page: "/signup",
	_root: "https://nezcdev.dataa.com.tw/",
	token: "",
	accessID: "",
	isAdmin: false,
	isLoading: false,
	isLoadingCnt: 0,
	init: function (view) {
		API.token = API._cookie.read('tk');
		API.accessID = API._cookie.read('ac');
		API.isAdmin = API.getIsAdmin();
		if (view) {
			API.currentView = view;
		} else {
			console.error("view", view, API.currentView);
		}
	},
	getIsAdmin: function () {
		let tmp = parseInt(API._cookie.read('ad'));
		return isNaN(tmp) ? "" : tmp;
	},
	setIsLoading: function (isLoading) {
		// console.log("[setIsLoading]", API.isLoading, API.isLoadingCnt)
		if (isLoading) {
			API.isLoadingCnt++;
			if (API.isLoadingCnt > 0) API.isLoading = true;
		} else {
			API.isLoadingCnt--
			if (API.isLoadingCnt <= 0) {
				API.isLoadingCnt = 0;
				API.isLoading = false;
			}
		}
		// console.log("[setIsLoading]", API.isLoading, API.isLoadingCnt)
	},
	getIsLoading: function () {
		return API.isLoading
	},
	ForgetPassword: async function (email) {
		// console.log(JSON.stringify(header), JSON.stringify(body));
		const { response, responseData } = await API.getPromise({
			path: "user/v1/ForgetPassword",
			headers: {},
			body: {
				'email': email
			},
			method: "post"
		});
		// const responseData = response.json();
		// console.log(responseData);
		return responseData;
	},
	ChangeForgetPassword: async function (body) {
		// console.log(JSON.stringify(header), JSON.stringify(body));
		const { response, responseData } = await API.getPromise({
			path: "user/v1/ChangeForgetPassword",
			headers: {},
			body: body,
			method: "post"
		});
		// const responseData = response.json();
		// console.log(responseData);
		return responseData;
	},
	SendEmailVerification: async function (email) {
		// console.log(JSON.stringify(header), JSON.stringify(body));
		const { response, responseData } = await API.getPromise({
			path: "user/v1/SendEmailVerification",
			headers: {},
			body: {
				'email': email
			},
			method: "post"
		});
		// const responseData = response.json();
		// console.log(responseData);
		return responseData;
	},
	SendPhoneVerification: async function (email, international_code, phone_num) {
		// console.log(JSON.stringify(header), JSON.stringify(body));
		const { response, responseData } = await API.getPromise({
			path: "user/v1/SendPhoneVerification",
			headers: {},
			body: {
				'email': email,
				'international_code': international_code,
				'phone_num': phone_num
			},
			method: "post"
		});
		// const responseData = response.json();
		// console.log(responseData);
		return responseData;
	},
	Login: async function (id, pw) {
		// Default options are marked with *
		const { response, responseData } = await API.getPromise({
			path: "back/v1/LoginAuthorize",
			headers: {
				'pw': pw,
				'id': id
			},
			method: "get"
		});

		console.log(response, responseData);
		const tk = response.headers.get("tk");
		const ac = response.headers.get("ac");
		// let isAdmin = (responseData && responseData.msg
		// 	&& responseData.msg.indexOf("管理者") >= 0);
		// if ("boolean" != typeof (isAdmin)) isAdmin = false;
		let isAdmin = responseData.user_type;
		if (null == isAdmin) isAdmin = 2;
		// console.log(responseData, tk, ac);
		API.token = tk;
		API.accessID = ac;
		API.isAdmin = isAdmin;
		const cookies = new Cookies();
		cookies.set('ac', ac, { path: '/' });
		cookies.set('tk', tk, { path: '/' });
		cookies.set('ad', isAdmin, { path: '/' });
		// console.log('[login] cookie check', cookies.get('ac'), cookies.get('tk'));
		return responseData;
	},
	Logout: async function () {
		// Default options are marked with *
		API.token = API._cookie.read('tk');
		API.accessID = API._cookie.read('ac');
		const { response, responseData } = await API.getPromise({
			path: "back/v1/Logout",
			headers: {
				// 'pw': pw,
				// 'id': id
			},
			method: "get"
		});
		API.token = "";
		API.accessID = "";
		API.isAdmin = false;
		const cookies = new Cookies();
		cookies.remove('ac', { path: '/' });
		cookies.remove('tk', { path: '/' });
		cookies.remove('ad', { path: '/' });
		cookies.remove('usr', { path: '/' });
		cookies.remove('point', { path: '/' });
		return responseData;
	},
	// Login: function(id, pw, onSucc){
	// 	API.ajaxSend("LoginAuthorize", "get", {'id':id, 'pw':pw}, null, function(data, jqXHR){
	// 		var tk = jqXHR.getResponseHeader('tk');
	// 		var ac = jqXHR.getResponseHeader('ac');
	// 		console.log(data, tk, ac );
	// 		API.token = tk;
	// 		API.accessID = ac;
	// 		const cookies = new Cookies();
	// 		cookies.set('ac', ac, { path: '/' });
	// 		console.log(cookies.get('ac'));
	// 		cookies.set('tk', tk, { path: '/' });
	// 		console.log(cookies.get('tk'));
	// 		onSucc(ac,tk);
	// 	});
	// },
	RegisterCustomerAccount: async function (body) {
		const { response, responseData } = await API.getPromise({
			path: "user/v1/RegisterCustomerAccount",
			headers: {},
			body: body,
			method: "post"
		});

		console.log(response, responseData);
		const tk = response.headers.get("tk");
		const ac = response.headers.get("ac");
		// let isAdmin = (responseData && responseData.msg
		// 	&& responseData.msg.indexOf("管理者") >= 0);
		// if ("boolean" != typeof (isAdmin)) isAdmin = false;
		let isAdmin = responseData.user_type;
		if (null == isAdmin) isAdmin = 2;
		// console.log(responseData, tk, ac);
		API.token = tk;
		API.accessID = ac;
		API.isAdmin = isAdmin;
		const cookies = new Cookies();
		cookies.set('ac', ac, { path: '/' });
		cookies.set('tk', tk, { path: '/' });
		cookies.set('ad', isAdmin, { path: '/' });
		// console.log('[login] cookie check', cookies.get('ac'), cookies.get('tk'));
		return responseData;
	},
	GetCustomerInfo: async function (header) {
		const { response, responseData } = await API.getPromise({
			path: "user/v1/GetCustomerInfo",
			headers: header,
			method: "get"
		});

		if (responseData) {
			console.log(responseData);
			const cookies = new Cookies();
			if (responseData.display_name) {
				cookies.set('usr', responseData.display_name, { path: '/' });
			}

			if (null != responseData.platform_point
				&& 1 == responseData.is_normal_member) {
				cookies.set('point', responseData.platform_point, { path: '/' });
			} else {
				cookies.remove('point', { path: '/' });
			}
		}
		// const responseData = response.json();
		// console.log(responseData);
		return responseData;
	},
	UpdateCustomer: async function (header, body) {
		// console.log(JSON.stringify(header), JSON.stringify(body));
		const { response, responseData } = await API.getPromise({
			path: "user/v1/UpdateCustomer",
			headers: header,
			body: body,
			method: "post"
		});
		// const responseData = response.json();
		// console.log(responseData);
		return responseData;
	},
	AddTestingMembers: async function (header, body) {
		// console.log(JSON.stringify(header), JSON.stringify(body));
		const { response, responseData } = await API.getPromise({
			path: "user/v1/AddTestingMembers",
			headers: header,
			body: body,
			method: "post"
		});
		// const responseData = response.json();
		// console.log(responseData);
		return responseData;
	},
	GetTestingMembers: async function (header) {
		// console.log(JSON.stringify(header), JSON.stringify(body));
		const { response, responseData } = await API.getPromise({
			path: "user/v1/GetTestingMembers",
			headers: header,
			method: "get"
		});
		// const responseData = response.json();
		// console.log(responseData);
		return responseData;
	},
	ChangePassword: async function (body) {
		const { response, responseData } = await API.getPromise({
			path: "user/v1/ChangePassword",
			headers: {},
			body: body,
			method: "post"
		});
		// const responseData = response.json();
		// console.log(responseData);
		return responseData;
	},
	// ------------ member ---------------
	GetMembers: async function (header) {
		const { response, responseData } = await API.getPromise({
			path: "back/members/v1/GetMembers",
			headers: header,
			method: "post"
		});
		// const responseData = response.json();
		// console.log(responseData);
		return responseData;
	},
	// GetMembers: function(header, onSucc, body){
	// 	//取得方式 (0=全會員, 1=篩選會員)
	// 	//sz = 數 
	// 	header = header || {};
	// 	header.ac = API.accessID;
	// 	header.tk = API.token;

	// 	API.ajaxSend("GetMembers", "post", header, body, function(data, jqXHR){
	// 		onSucc(data);
	// 	});
	// },
	GetMemberPointRecord: function (data, onSucc) {
		data = data || {};
		data.ac = API.accessID;
		data.tk = API.token;

		API.ajaxSend("GetMemberPointRecord", "get", data, null, function (data, jqXHR) {
			onSucc(data);
		});
	},
	// ----------- projects -------------
	GetProjects: function (data, onSucc) {
		//取得方式 (0=全會員, 1=篩選會員)
		//sz = 數 
		data = data || {};
		data.ac = API.accessID;
		data.tk = API.token;

		API.ajaxSend("back/projects/v1/GetProjects", "get", data, null, function (data, jqXHR) {
			onSucc(data);
		});
	},
	GetProjectByID: async function (header) {
		const { response, responseData } = await API.getPromise({
			path: "back/projects/v1/GetProjects",
			headers: header,
			method: "get"
		});
		// const responseData = response.json();
		// console.log(responseData);
		return { response, responseData };
	},
	AddProject: async function (header, data) {
		const { response, responseData } = await API.getPromise({
			path: "back/projects/v1/AddProject",
			headers: header,
			method: "post",
			body: data
		});
		// const responseData = response.json();
		// console.log(responseData);
		return { response, responseData };
	},
	GetAnswerRecordContentCSV: async function (header) {
		const { response, responseData } = await API.getPromise({
			path: "csv/v1/GetAnswerRecordContentCSV",
			headers: header,
			method: "get"
		}, true);
		// const responseData = response.json();
		// console.log(response, responseData);
		return { response, responseData };
	},
	GetAnswerRecordCSV: async function (header) {
		const { response, responseData } = await API.getPromise({
			path: "csv/v1/GetAnswerRecordCSV",
			headers: header,
			method: "get"
		}, true);
		// const responseData = response.json();
		// console.log(response, responseData);
		return { response, responseData };
	},
	GetAnswerRecord: async function (header) {
		const { response, responseData } = await API.getPromise({
			path: "back/projects/v1/GetAnswerRecord",
			headers: header,
			method: "get"
		});
		// const responseData = response.json();
		// console.log(response, responseData);
		return { response, responseData };
	},
	GetQuestionOptionsCSV: async function (header) {
		const { response, responseData } = await API.getPromise({
			path: "csv/v1/GetQuestionOptionsCSV",
			headers: header,
			method: "get"
		}, true);
		// const responseData = response.json();
		// console.log(response, responseData);
		return { response, responseData };
	},
	CustomerSendProject: async function (header, body) {
		const { response, responseData } = await API.getPromise({
			path: "back/v1/CustomerSendProject",
			headers: header,
			body: body,
			method: "post"
		});
		// const responseData = response.json();
		// console.log(response, responseData);
		return { response, responseData };
	},
	MemberFilter: async function (body) {
		const { response, responseData } = await API.getPromise({
			path: "back/members/v1/MemberFilter",
			headers: {},
			body: body,
			method: "post"
		});
		// const responseData = response.json();
		// console.log(response, responseData);
		return { response, responseData };
	},
	GetCustomerIncubators: async function (header) {
		const { response, responseData } = await API.getPromise({
			path: "back/members/v1/GetCustomerIncubators",
			headers: header,
			// body: ,
			method: "post"
		});
		// const responseData = response.json();
		// console.log(response, responseData);
		return { response, responseData };
	},
	// ------------ goods ---------------
	GetGoods: function (data, onSucc) {
		//取得方式 (0=全會員, 1=篩選會員)
		//sz = 數 
		data = data || {};
		data.ac = API.accessID;
		data.tk = API.token;

		API.ajaxSend("back/goods/v1/GetGoods", "get", data, null, function (data, jqXHR) {
			onSucc(data);
		});
	},
	AddGood: function (header, body, onSucc, onFail) {
		header = header || {};
		header.ac = API.accessID;
		header.tk = API.token;

		API.ajaxSend("back/goods/v1/AddGood", "post", header, body, function (data, jqXHR) {
			onSucc(data);
		}, function (jqXHR) {
			onFail(jqXHR);
		});
	},
	GetGoodRecord: function (data, onSucc) {
		//取得方式 (0=全會員, 1=篩選會員)
		//sz = 數 
		data = data || {};
		data.ac = API.accessID;
		data.tk = API.token;

		API.ajaxSend("back/goods/v1/GetGoodRecord", "get", data, null, function (data, jqXHR) {
			onSucc(data);
		});
	},
	// ------------ ads ---------------
	GetAds: function (data, onSucc) {
		//取得方式 (0=全會員, 1=篩選會員)
		//sz = 數 
		data = data || {};
		data.ac = API.accessID;
		data.tk = API.token;

		API.ajaxSend("back/ads/v1/GetAds", "get", data, null, function (data, jqXHR) {
			onSucc(data);
		});
	},
	GetAdClickIndex: function (data, onSucc) {
		//取得方式 (0=全會員, 1=篩選會員)
		//sz = 數 
		data = data || {};
		data.ac = API.accessID;
		data.tk = API.token;

		API.ajaxSend("back/ads/v1/GetAdClickIndex", "get", data, null, function (data, jqXHR) {
			onSucc(data);
		});
	},
	AddAds: function (header, body, onSucc, onFail) {
		header = header || {};
		header.ac = API.accessID;
		header.tk = API.token;

		API.ajaxSend("back/ads/v1/AddAds", "post", header, body, function (data, jqXHR) {
			onSucc(data);
		}, function (jqXHR) {
			onFail(jqXHR);
		});
	},
	// ------------ order ---------------
	GetProducts: async function (body) {
		const { response, responseData } = await API.getPromise({
			path: "back/order/v1/GetProducts",
			headers: {},
			body: body,
			method: "post"
		});
		// const responseData = response.json();
		// console.log(responseData);
		return responseData;
	},
	AddChargeOrder: async function (body) {
		const { response, responseData } = await API.getPromise({
			path: "back/order/v1/AddChargeOrder",
			headers: {},
			body: body,
			method: "post"
		});
		// const responseData = response.json();
		// console.log(responseData);
		return responseData;
	},
	PaymentEstimate: async function (body) {
		const { response, responseData } = await API.getPromise({
			path: "back/order/v1/PaymentEstimate",
			headers: {},
			body: body,
			method: "post"
		});
		// const responseData = response.json();
		// console.log(responseData);
		return responseData;
	},
	OrderPlatformPointPayment: async function (body) {
		const { response, responseData } = await API.getPromise({
			path: "back/order/v1/OrderPlatformPointPayment",
			headers: {},
			body: body,
			method: "post"
		});
		// const responseData = response.json();
		// console.log(responseData);
		return responseData;
	},
	OrderOnlinePayment: async function (body) {
		const { response, responseData } = await API.getPromise({
			path: "back/order/v1/OrderOnlinePayment",
			headers: {},
			body: body,
			method: "post"
		});
		// if (responseData.URL
		// 	&& responseData.Method
		// 	&& responseData.MerchantID
		// 	&& responseData.TradeInfo
		// 	&& responseData.TradeSha
		// 	&& responseData.Version) {

		// 	var formData = new FormData();
		// 	// var fileField = document.querySelector("input[type='file']");

		// 	formData.append('MerchantID', responseData.MerchantID);
		// 	formData.append('TradeInfo', responseData.TradeInfo);
		// 	formData.append('TradeSha', responseData.TradeSha);
		// 	formData.append('Version', responseData.Version);
		// 	// formData.append('avatar', fileField.files[0]);
		// 	console.log(responseData, formData);
		// 	for (var pair of formData.entries()) {
		// 		console.log(pair[0] + ', ' + pair[1]);
		// 	}

		// 	const { formResponse, formResponseData } = await API.getPromise({
		// 		path: responseData.URL,
		// 		headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
		// 		body: formData,
		// 		method: responseData.Method,
		// 		isFullPath: true,
		// 		isAutoCompleteHeader: false,
		// 		isJson: false
		// 	});
		// 	return formResponseData;
		// }
		return responseData;
	},
	AddProjectOrder: async function (body) {
		const { response, responseData } = await API.getPromise({
			path: "back/order/v1/AddProjectOrder",
			headers: {},
			body: body,
			method: "post"
		});
		// const responseData = response.json();
		// console.log(responseData);
		return responseData;
	},
	GetTransactionRecord: async function (body) {
		const { response, responseData } = await API.getPromise({
			path: "back/order/v1/GetTransactionRecord",
			headers: {},
			body: body,
			method: "post"
		});
		// const responseData = response.json();
		// console.log(responseData);
		return responseData;
	},
	GetOrders: async function (body) {
		const { response, responseData } = await API.getPromise({
			path: "back/order/v1/GetOrders",
			headers: {},
			body: body,
			method: "post"
		});
		// const responseData = response.json();
		// console.log(responseData);
		return responseData;
	},

	//------------- ??? ---------------
	LotteryDraw: function (data, onSucc) {
		//取得方式 (0=全會員, 1=篩選會員)
		//sz = 數 
		data = data || {};
		data.ac = API.accessID;
		data.tk = API.token;

		API.ajaxSend("LotteryDraw", "post", data, null, function (data, jqXHR) {
			onSucc(data);
		});
	},
	GetQuestionnaire: async function (header) {
		const { response, responseData } = await API.getPromise({
			path: "back/projects/v1/GetQuestionnaire",
			headers: header,
			method: "get"
		});
		// const responseData = response.json();
		// console.log(responseData);
		return { response, responseData };
	},
	AddQuestionnaire: async function (header, body) {
		const { response, responseData } = await API.getPromise({
			path: "back/projects/v1/AddQuestionnaire",
			headers: header,
			method: "post",
			body: body
		});
		// const responseData = response.json();
		// console.log(responseData);
		return { response, responseData };
	},
	ImageUpload: async function (header, body) {
		const { response, responseData } = await API.getPromise({
			path: "back/v1/ImageUpload",
			headers: header,
			method: "post",
			body: body
		});
		// const responseData = response.json();
		// console.log(responseData);
		return { response, responseData };
	},
	ProjectDuplicate: async function (header) {
		const { response, responseData } = await API.getPromise({
			path: "back/projects/v1/ProjectDuplicate",
			headers: header,
			method: "get"
		});
		const newPi = response.headers.get("pi");
		return { response, responseData, newPi };
	}
}
// export default API;

const mapStateToProps = (state) => ({
	ac: state.authReducer.ac,
	tk: state.authReducer.tk
})

const mapDispatchToProps = {
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(API))